
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 35 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35 3.314a14.471 14.471 0 0 1-4.124 1.113 7.106 7.106 0 0 0 3.157-3.91 14.512 14.512 0 0 1-4.56 1.715A7.224 7.224 0 0 0 24.233 0c-3.966 0-7.182 3.165-7.182 7.069 0 .553.064 1.093.186 1.61a20.49 20.49 0 0 1-14.8-7.385 6.95 6.95 0 0 0-.973 3.553c0 2.453 1.268 4.616 3.195 5.884a7.232 7.232 0 0 1-3.252-.885l-.001.09c0 3.424 2.475 6.281 5.76 6.93a7.297 7.297 0 0 1-3.243.122c.914 2.808 3.566 4.852 6.708 4.909a14.553 14.553 0 0 1-8.919 3.026c-.579 0-1.15-.034-1.712-.099A20.557 20.557 0 0 0 11.007 28c13.209 0 20.43-10.771 20.43-20.112 0-.305-.006-.611-.02-.915A14.448 14.448 0 0 0 35 3.314","fill":"#232323","fill-rule":"evenodd"}})])
          )
        }
      }
    